/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Transfer
 */
export interface TransferDto {
  asset: string;
  direction: TransferDto.DirectionEnum;
  requestedQuantity: number;
  quantity: number;
  allowReduceQuantityTo?: number;
  createTime: string;
  settleTime?: string;
  status: TransferDto.StatusEnum;
  note?: string;
  txHash?: string;
  /**
   * Other account of INTERNAL_DEPOSIT/INTERNAL_WITHDRAW transfer between main account and its subaccount.
   */
  linkedAccountId?: number;
}
export namespace TransferDto {
  export const DirectionEnum = {
    Deposit: 'DEPOSIT',
    Withdraw: 'WITHDRAW',
    InternalDeposit: 'INTERNAL_DEPOSIT',
    InternalWithdraw: 'INTERNAL_WITHDRAW',
  } as const;
  export type DirectionEnum = (typeof DirectionEnum)[keyof typeof DirectionEnum];
  export const StatusEnum = {
    Pending: 'PENDING',
    Error: 'ERROR',
    Settled: 'SETTLED',
  } as const;
  export type StatusEnum = (typeof StatusEnum)[keyof typeof StatusEnum];
}
